import {faBars as hamburgerMenu} from '@fortawesome/free-solid-svg-icons/faBars';
import {faComments as chatBubbles} from '@fortawesome/free-solid-svg-icons/faComments';
import {faTimes as x} from '@fortawesome/free-solid-svg-icons/faTimes';

export default {
    chatBubbles,
    hamburgerMenu,
    x,
};